export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_22720_51401)">
      <circle cx="9.14295" cy="9.14783" r="8.292" stroke="#290042" strokeWidth="1.7019" />
      <path
        d="M15.2869 15.1826L19.1042 19"
        stroke="#290042"
        strokeWidth="1.7019"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_22720_51401">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
